import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AccountAuthorization } from 'src/model/accountAuthorization';
import { AccountAuthorizationService } from 'src/services/accountAuthorization.service';

@Component({
    selector: 'app-add-account-authorization-request',
    templateUrl: './add-account-authorization-request.component.html',
    styleUrl: './add-account-authorization-request.component.scss',
    standalone: false
})
export class AddAccountAuthorizationRequestComponent {
  private activeModal = inject(NgbActiveModal);
  private accountAuthorizationService = inject(AccountAuthorizationService);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);

  disabledSubmit = false;
  grantRemark: string;
  date: Date;
  reason: string;

  @Input() customerId: number;
  @Input() contactId: number;
  @Input() accountId: number;

  @Output() passEntry = new EventEmitter<any>();

  isAllowSelfApprove = false;

  reset() {
    this.activeModal.close();
  }

  checkError() {
    let empty = "";

    if (this.isAllowSelfApprove == true) {
      if (this.date == undefined)
        empty += "- Date \n";
      if (this.grantRemark == undefined || this.grantRemark == "")
        empty += "- Remark \n";
    }

    if (this.reason == undefined || this.reason == "")
      empty += "- Reason \n";

    if (empty != "")
      return "Please fix following error before submitting:\n" + empty;
    else
      return empty;
  }

  submit() {
    const error = this.checkError();
    if (error == "") {
      const authorization = new AccountAuthorization(undefined, this.reason, this.date, this.grantRemark);
      const result = this.accountAuthorizationService.getAddAccountAuthrozation(this.customerId, this.accountId, authorization);

      if (result != undefined) {
        this.sharedService.openAlert("Successfully created authorization request!", ALERT_TYPE.SUCCESS);
        this.activeModal.close();
      }
    }
    else
      this.sharedService.openAlert(error, ALERT_TYPE.DANGER)
  }
}
